import React, { PropsWithChildren } from 'react'

import { CardBanner } from './CardBanner'
import { CardContent } from './CardContent'
import { IProps } from './IProps'
import { CardContainer } from './style'

export const Card = (props: PropsWithChildren<IProps>) => {
  return (
    <CardContainer
      color={props.fontColor}
      hover={props.hoverSensitive}
      width={props.cardWidth}
      height={props.cardHeight}
      bgColor={props.backgroundColor}
      bgGradient={props.backgroundGradient}
      style={props.style}
      onClick={props.onClick}>
      {props.bannerImage ? (
        <CardBanner height={props.bannerHeight} src={props.bannerImage} />
      ) : null}

      <CardContent style={props.styleInnerContent}>
        {props.children}
      </CardContent>
    </CardContainer>
  )
}
